import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";

import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import CommonSourceAccount from "../../_utils/TransactionCommonComponents/CommonSourceAccount";

import CommonLayout from "../../_utils/CommonLayout";
import CommonDestinationAccount from "../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import globalText from "../../../utils/globalText";
import FieldForceAccountViewAll from "../../../containers/Accounts/FieldForceAccount/FieldForceAccountViewAll";
import ICONS from "../../../assets/Icons";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import { useNavigate } from "react-router-dom";

const FieldForceCreateTxnSelectAccount = (props) => {
  const MIN_ASSOCIATES = GlobalConfiguration.lengthCheckOne;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [remPan, setRemPan] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [bankLogo, setBankLogo] = useState(
    props?.txnPayLoad?.bankLogo ? props?.txnPayLoad?.bankLogo : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [accountName, setAccountName] = useState(
    props?.txnPayLoad?.bankAccountName
      ? props?.txnPayLoad?.bankAccountName
      : "",
  );
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );

  const [activeType, setActiveType] = useState("pan");

  const { beneSuccessData } = useSelector(
    (state) => state?.beneCreateAccountSlice,
  );

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state?.beneAllVerification?.beneLookData,
  );

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > MIN_ASSOCIATES || havePANAssociate > MIN_ASSOCIATES) &&
    accountNumber &&
    IFSC;

  useEffect(() => {
    if (props?.associateModalOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props?.associateModalOpen]);

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleOpenDestinationAccountPopup = () => {
    props?.setIsModalOpen(true);
  };

  const handleOpenAssociatedAccountsPopup = () => {
    setRemPan(props?.txnPayLoad?.pan);
    setOpenBeneAssociate(true);
  };

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  useEffect(() => {
    if (props?.txnPayLoad?.pan) {
      dispatch(beneLookUp({ pan_number: props?.txnPayLoad?.pan }));
    }
  }, [props?.txnPayLoad?.pan]);

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    setAccountName(accountName);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    const isRecreateFlow = props?.mapingData === "renderData";
    const isAccountChanged =
      props?.txnPayLoad?.beneAccountId &&
      props?.txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      props?.setSelectedCategory(null);
      props?.setCatShow(true);
      props?.setCatSelect(false);
    }

    dispatch(beneLookUp({ pan_number: panNo }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );

    let matchedCategory = null;

    if (
      props?.type === "PayFieldForceTxn" &&
      categoriesArray.length > GlobalConfiguration?.lengthCheckZero
    ) {
      props?.setSelectedCategory({
        name: categoriesArray[0],
        configuration: props?.categories?.find((cat) =>
          cat?.category_name
            ?.toLowerCase()
            .includes(categoriesArray[0].toLowerCase()),
        )?.configuration,
      });
    }

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory: matchedCategory ?? null,
      amountWords: "",
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    handleCloseModal();

    if (beneSuccessData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      props?.setAccountSelect(false);
      props?.setCatShow(true);
    }
  };

  useEffect(() => {
    if (props?.mapingData === "renderData" && props?.accountSelect) {
      handleAccountSelection(
        beneSuccessData?.beneficiary_accounts?.[0]?.name,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_acc_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.ifsc_code,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_name,
        beneSuccessData?.beneficiary_accounts?.[0]?.category,
        beneSuccessData?.beneficiary_accounts?.[0]?.pan_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.id,
        beneSuccessData?.beneficiary_accounts?.[0]?.labels,
      );
      props?.setCatShow(true);
    }
  }, [props?.mapingData, props?.accountSelect]);

  return (
    <>
      {/* Select destination account popup (moved from FieldForceTxnDestAcc) */}
      {props?.isModalOpen && (
        <div className="absolute top-top-base left-left-base w-full-width min-h-full-height flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            closeiconhandleFunction={() => {
              props?.setIsModalOpen(false);
            }}
            isfullViewrequired={true}
            togglepan={() => {
              setActiveType("pan");
              setRemAccount("");
              setRemIFSC("");
            }}
            toggleBank={() => {
              setActiveType("bank");
              setRemPan("");
            }}
            fullviewbtnText="Register a new account"
            redirectHeader="Register a new account"
            fullviewhandleFunction={() => {
              navigate(
                "/field_force_account_dashboard/create_field_force_account",
              );
            }}
            redirectIcon={ICONS?.ADD_BUTTON_WHITE}
            fullviewicon={ICONS?.REDIRECT}
            isbottomSectionneed={false}
            headerTitle={"Field force account"}
            headersubtext={
              "Only active (pending & approved) accounts are enabled for selection."
            }
          >
            <FieldForceAccountViewAll
              type={"fieldForceAccount"}
              flow="create"
              setModalOpen={props?.setIsModalOpen}
              setTxnPayLoad={props?.setTxnPayLoad}
              onAccountSelect={handleAccountSelection}
            />
          </LargePopupRedirect>
        </div>
      )}

      {/* Associated accounts popup (moved from FieldForceTxnDestAcc) */}
      {openBeneAssociate && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated accounts"
            headersubtext="The accounts listed below are linked to the selected field force account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setOpenBeneAssociate(false);
              setRemPan("");
              setRemAccount("");
              setRemIFSC("");
              setActiveType("pan");
            }}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            confirmbtnrequired={true}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
            ispanbankRequired={true}
            togglepan={() => {
              setActiveType("pan");
              setRemPan(props?.txnPayLoad?.pan);
              setRemAccount("");
              setRemIFSC("");
            }}
            toggleBank={() => {
              setActiveType("bank");
              setRemPan("");
              setRemAccount(props?.txnPayLoad?.bankAccountNo);
              setRemIFSC(props?.txnPayLoad?.bankAccountIFSC);
            }}
          >
            <FieldForceAccountViewAll
              type={"fieldForceAccount"}
              popupType={"associated"}
              fieldForcePan={remPan}
              fieldForceAccountNo={remAccount}
              fieldForceIFSC={remIFSC}
              setOpenBeneAssociate={setOpenBeneAssociate}
              openBeneAssociate={openBeneAssociate}
              setTxnPayLoad={props?.setTxnPayLoad}
              flow={"create"}
              setModalOpen={props?.setIsModalOpen}
              onAccountSelect={handleAccountSelection}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="w-width-full  Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg pt-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <CommonSourceAccount
              type="source"
              modalOpen={props?.openOwner}
              setModalOpen={props?.setOpenOwner}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
              TypeRTGS={props?.TypeRTGS}
              currentAccountDetails={props?.currentAccountDetails}
              isFieldforce={true}
            />
          </div>
          <div className="flex flex-col gap-gap-md">
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] ${
                props?.type === "PayFieldForceTxn"
                  ? "opacity-light-opacity pointer-events-none"
                  : !props?.txnPayLoad?.ownerBankAccountNo
                    ? "opacity-light-opacity pointer-events-none"
                    : "opacity-base-opacity"
              }`}
            >
              <CommonDestinationAccount
                transactionPayload={props.txnPayLoad}
                setTransactionPayload={props.setTxnPayLoad}
                onSelectAccount={handleOpenDestinationAccountPopup}
                requiresSourceAccount
                showCreateAccount={true}
                showEditButton={false}
                isEditDisabled={false}
                createAccountButtonText={globalText?.REGISTER_NEW_ACCOUNT}
                registerRoute="/field_force_account_dashboard/create_field_force_account"
                showsBalance={false}
                showAssociatedAccounts={shouldShowAssociatedAccounts}
                onViewAssociatedAccounts={handleOpenAssociatedAccountsPopup}
                associatedAccountsText="Other existing field force accounts found"
              />
            </div>
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default FieldForceCreateTxnSelectAccount;
